/**
 * This labels are used in the calculator component.
 */
export const calculatorLabels = {
    title: 'Cotiza y preevalúa tu crédito en línea',
    summary: `
        Elige el plan de financiamiento que más se adapte a ti y 
        configúralo.`,
    description: `
        Contínua con la preevaluación de tu crédito de una manera
        rápida y sencilla, solo llena tus datos y en segundos
        obtendrás un resultado. Estas a un paso de estrenar tu
        próximo {brand}.
    `,
    financingTitle: 'Elige el plan de financiamiento',
    percentageTitle: 'Selecciona el porcentaje de enganche',
    timeToPaymentTitle: 'Selecciona el plazo',
};
